import { useEffect, useState } from "react";

function useIsMobile() {
    const [isMobile, setIsMobile] = useState(getIsMobile());

    useEffect(() => {
        const onResize = () => {
            setIsMobile(getIsMobile());
        };

        window.addEventListener("resize", onResize);

        return () => {
            window.removeEventListener("resize", onResize);
        };
    }, []);

    return isMobile;
}

function getIsMobile() {
    return window.innerWidth < 940;
}

export default useIsMobile;